export default __webpack_public_path__ + "static/media/warningIcon.a1d8d054.svg";